import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

export default function ArtistCard(props) {
    return (
        <Card>
            <CardMedia
                component="img"
                image={props.image}
                alt={props.name}
                sx={{
                    width: '100%',
                    aspectRatio: props.aspectRatio,
                    objectFit: 'cover'
                }}
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {props.name}
                </Typography>
                <Typography sx={{whiteSpace: 'break-spaces'}} variant="body2" color="text.secondary">
                    {props.description}
                </Typography>
            </CardContent>
        </Card>
    )
}